import Repository from "@/repository";
import router from '@/router'

export default {
  state: {
    user: localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : {},
    lastSupervision: null
  },
  getters: {
    isAuthenticated() {
      return Boolean(localStorage.getItem("userData"))
    },
  },
  actions: {
    async login({ commit, dispatch }, { username, password }) {
      commit("setLoadersCount", "+")
      const { value, error } = await Repository.Auth.login({ username, password })
      commit("setLoadersCount", "-")
      if (!error && value) {
        commit("setUserData", value)
        Repository.connector.setAuthHeaders(value.access);
        const id = await dispatch("getOpenSupervision")
        if (id) {
          window.location.href = `/ticker/${id}`;
        }
        else {
          window.location.href = "/select-roles";
        }

        return false
      }
      else {
        return error
      }
    },
    async getOpenSupervision({ commit }) {
      commit("setLoadersCount", "+")
      const { value, error } = await Repository.Supervision.getOpen()
      commit("setLoadersCount", "-")
      if (value && value.id) {
        commit("setLastSupervision", value)
        return value.id
      }
      else {
        commit("setLastSupervision", null)
        return null
      }
    }
  },
  mutations: {
    setUserData(state, value) {
      localStorage["userData"] = JSON.stringify(value);
      state.user = value
    },
    clearUserData(state) {
      localStorage.removeItem("userData");
      state.user = {}
    },
    setLastSupervision(state, value) {
      state.lastSupervision = value
    }
  },
};
